import type {
  CreateRequestInput,
  DeploymentLocation,
  DeploymentPeriod,
  ExtraInfo,
  RequestMotivation,
  RequestedAssetLine,
  RequesterDetails,
} from "@/domains/requests/api/types";

export const EMPTY_REQUESTER: RequesterDetails = {
  lastName: "",
  firstName: "",
  email: "",
  phone: "",
  service: "",
  serviceContactDetails: "",
};

export const EMPTY_PERIOD: DeploymentPeriod = {
  startDate: "",
  deploymentStart: "",
  endDate: "",
  extensionPossible: false,
};

export const EMPTY_LOCATION: DeploymentLocation = {
  address: "",
  locationAndCameraDirection: "",
  polePresence: "yes",
  photos: [],
  environmentalFactors: "",
};

export const EMPTY_EXTRA_INFO: ExtraInfo = {
  event: "",
  eventInfo: "",
  parkingSigns: "",
};

export const EMPTY_MOTIVATION: RequestMotivation = {
  reason: "",
  pvNumber: "",
  specialAuthorization: "",
  multipleDeployment: "",
  complianceConfirmed: false,
};

export const EMPTY_ASSETS: ReadonlyArray<RequestedAssetLine> = [];

export function createEmptyAssetLine(): RequestedAssetLine {
  return {
    id: `line-${Math.random().toString(36).slice(2, 10)}`,
    assetType: "",
    quantity: 1,
    note: "",
  };
}

export const EMPTY_WIZARD: CreateRequestInput & { title: string; qualityConfirmed: boolean } = {
  title: "",
  requesterId: "",
  requester: EMPTY_REQUESTER,
  assets: EMPTY_ASSETS,
  period: EMPTY_PERIOD,
  location: EMPTY_LOCATION,
  extraInfo: EMPTY_EXTRA_INFO,
  motivation: EMPTY_MOTIVATION,
  qualityConfirmed: false,
};

export const WIZARD_STEPS = [
  { id: "requester", label: "Aanvrager" },
  { id: "assets", label: "Materiaal" },
  { id: "period", label: "Periode" },
  { id: "location", label: "Locatie" },
  { id: "extra", label: "Bijkomende info" },
  { id: "motivation", label: "Motivatie" },
  { id: "submit", label: "Indienen" },
] as const;

export type WizardStepId = (typeof WIZARD_STEPS)[number]["id"];
